// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

// so when a modulation gets validated in the backend, it is validated as a db entity.
// the hibernate session is getting flushed when validating radio code. as a result, it is assigned an id.
// when the validation exception is thrown, the entity is thrown along with it.
// so when validation fails against a new modulation, the error object will
// have an entityId for it even though it shouldn't. This cleans out the ids
// of new modulations which haven't yet been saved to the db to help
// the passing of these errors down from radio details > modulation details form.

const removeErroneousRadioModulationIdFromErrors = err => (dispatch, getState) => {
  // if there is no errors list to massage, get outta here
  if (!err?.json?.errors) {
    return
  }

  // to support new modulations, a fake radioModulationId is assigned.
  // the fake id will be of the following pattern: `temp-modulation-id-${Date.now()}`
  // See formatModulationData.js for where this is created.
  // casting the radioModulationId to float will make the temp ids become null
  // and set the radioModulationId as an integer for the existing ones.
  const storedRadioModulationIds = (
    getState().databaseDetails
      .getIn(['initialValues', 'radioModulations'])
      .map(d => castToFloat(d.get('radioModulationId')))
  )

  err.json.errors.forEach(d => {
    if (
      d.entityType === 'RADIO_MODULATION' && (
        d.entityId === 0 ||
        storedRadioModulationIds.includes(d.entityId) === false
      )
    ) {
      d.entityId = null
    }
  })
}

export default removeErroneousRadioModulationIdFromErrors
